<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.33334 16.6667V10C2.33334 9.55798 2.50894 9.13406 2.8215 8.8215C3.13406 8.50894 3.55798 8.33334 4.00001 8.33334M4.00001 8.33334H17.3333M4.00001 8.33334V5.00001C4.00001 4.55798 4.1756 4.13406 4.48817 3.8215C4.80073 3.50894 5.22465 3.33334 5.66668 3.33334H15.6667C16.1087 3.33334 16.5326 3.50894 16.8452 3.8215C17.1577 4.13406 17.3333 4.55798 17.3333 5.00001V8.33334M17.3333 8.33334C17.7754 8.33334 18.1993 8.50894 18.5119 8.8215C18.8244 9.13406 19 9.55798 19 10V16.6667M10.6667 3.33334V8.33334M2.33334 15H19" stroke="#30485E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "BedIcon"
}
</script>
